import { render, staticRenderFns } from "./page.vue?vue&type=template&id=261edfe2&scoped=true&"
import script from "./page.vue?vue&type=script&lang=ts&"
export * from "./page.vue?vue&type=script&lang=ts&"
import style0 from "./page.vue?vue&type=style&index=0&id=261edfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261edfe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261edfe2')) {
      api.createRecord('261edfe2', component.options)
    } else {
      api.reload('261edfe2', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=261edfe2&scoped=true&", function () {
      api.rerender('261edfe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/tabs/page.vue"
export default component.exports